import { createStore, applyMiddleware } from 'redux';
import venueManagerReducer from '../reducers/venueManagerReducer';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';

const configureStore = (railsProps) => (
  createStore(venueManagerReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
